import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'HireAsset';

const routes = [
    {
        matchRegex: '/HireAsset',
        name: getRouteName(MODULE_NAME, 'Listing'),
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
            SLOT_KEY.SLOT_SCRIPTS,
        ],
        image: PreviewDListlImg,
    },
    {
        matchRegex: '/HireAsset/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Detail'),
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_TAB,
            SLOT_KEY.SLOT_CONTENT,
            SLOT_KEY.SLOT_RIGHT_SECTION_FORM,
            SLOT_KEY.SLOT_SCRIPTS,
        ],
        image: PreviewDetailImg,
    },
    {
        matchRegex: '/HireContract/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Hire Contract Detail'),
        slots: [
            SLOT_KEY.SLOT_V_SECTION,
            SLOT_KEY.SLOT_SCRIPTS
        ],
        image: PreviewDetailImg,
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                {
                    key: 'MARKETPLACE_EVENT_AFTER_SAVE_HIRE_ITEM_SUCCESS',
                    label: 'Trigger After Save Hire Item Success',
                },
                {
                    key: 'MARKETPLACE_EVENT_AFTER_DELETE_HIRE_ITEM_SUCCESS',
                    label: 'Trigger After Delete Hire Item Success',
                },
            ],
        },
        parentKeys: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'hire-item-unit', label: 'Hire Item Unit' },
            ],
        },
    },
    {
        matchRegex: '/HireQuote/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Hire Quote Detail'),
        slots: [
            SLOT_KEY.SLOT_V_SECTION,     
        ],
        image: PreviewDetailImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'hire-item-unit', label: 'Hire Item Unit' },
            ],
        },
    },
]

export default routes;